/**
 * Author:hong.rong
 * Desc:素材盘列表
 * Date:2022-09-15
 */

import React, { useState, useEffect, useRef } from 'react'
import isFunction from 'lodash/isFunction'
import { useTranslation } from '@/libs/next-lang'
import { transformBread } from '../utils'
import MaterialLibrary from './MaterialLibrary'

const initialBread = { uuid: '', name: '/' }

export default ({ accept, fileListParams, getFilesList, onChange, translateTxt }: any) => {
  const [loading, setLoading] = useState(true)
  const [dataSource, setDataSource] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  const [breadList, setBreadList] = useState<any[]>([initialBread])
  const breadRef = useRef<any>(initialBread) // 当前面包屑
  const isExceed = useRef(false) // 面包屑文案长度是否超出

  const { t } = useTranslation(['components'])

  useEffect(() => {
    return () => {
      breadRef.current = { uuid: '', name: '/' }
      isExceed.current = false
    }
  }, [])

  /**
   * 获取新的breadList
   * @param currentBread
   * @param currentBreadList
   */
  const getNewBreadList = (currentBread, currentBreadList) => {
    const dom: any = document.getElementById('breadcrumb-content') || {}
    const areaWidth = dom.offsetWidth - 25
    let totalWidth = 0
    const transList = transformBread(currentBreadList, currentBread, t('components:panDisk.t2'))
    totalWidth = transList.reduce((accumulator, currentValue) => {
      return accumulator + (currentValue.textWidth || 0)
    }, 0)
    if (transList.length > 1) {
      totalWidth = totalWidth + (transList.length - 1) * (8 + 9 + 8)
    }
    isExceed.current = totalWidth > areaWidth && areaWidth > 0
    if (isExceed.current) {
      // 超出长度，设置隐藏
      transList.splice(1, transList.length - 2, { name: '...', value: 'ellipsis' })
    }
    return transList
  }

  /**
   * 请求列表数据
   */
  const getData = async params => {
    if (!isFunction(getFilesList)) {
      return
    }
    try {
      const { data = {} } = await getFilesList({ ...params })
      if (data?.code === 0) {
        const result = data?.result || {}
        setDataSource(result?.files || [])
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (fileListParams && getFilesList) {
      setLoading(true)
      getData({ ...fileListParams, pathUuid: breadRef.current?.uuid })
    }
  }, [])

  /**
   * 面包屑点击
   * @param breadItem
   * @param breadIndex
   */
  const handleBread = async (breadItem, breadIndex) => {
    setLoading(true)
    setSelectedRows([])
    onChange && onChange([])
    // 缓存当前面包屑
    breadRef.current = { uuid: breadItem.uuid, name: breadItem.name }
    // 删除当前面包屑后的所有面包屑
    const newBreadList = [...breadList]
    newBreadList.splice(breadIndex + 1)
    // 重新计算面包屑长度是否溢出
    setBreadList(transformBread(newBreadList, null, t('components:panDisk.t2')))
    await getData({ pathUuid: breadItem.uuid })
  }

  /**
   * 文件夹点击
   * @param row
   */
  const handleClickFolder = async row => {
    setLoading(true)
    setSelectedRows([])
    onChange && onChange([])
    // 缓存当前面包屑
    breadRef.current = { uuid: row.uuid, name: row.name }
    // 重新计算面包屑长度是否溢出
    setBreadList(getNewBreadList(breadRef.current, breadList))
    // 点击文件夹进入下一层
    await getData({ pathUuid: row.uuid })
  }

  /**
   * 搜索 // 默认是搜二级下的提供物与中间产物，如果在列表中点击进入下一层，即搜索里面文件
   * @param e
   */
  const handleSearch = async e => {
    setLoading(true)
    await getData({
      keyword: e,
      pathUuid: breadRef.current?.uuid,
    })
  }

  /**
   * 选择行
   * @param e
   */
  const handleSelectedRows = e => {
    setSelectedRows(e)
    onChange && onChange(e)
  }

  return (
    <MaterialLibrary
      loading={loading}
      accept={accept}
      breadList={breadList}
      dataSource={dataSource}
      isExceed={isExceed.current}
      selectedRows={selectedRows}
      onBreadClick={handleBread}
      onFolderClick={handleClickFolder}
      onSearch={handleSearch}
      onRowSelect={handleSelectedRows}
      translateTxt={translateTxt}
    />
  )
}
